import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { CommonConstants } from 'src/app-core/constants/common-constants';

@Component({
    selector: 'app-clone-confirmation-popup',
    templateUrl: './clone-confirmation-popup.component.html',
    styleUrls: ['./clone-confirmation-popup.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CloneConfirmationPopupComponent implements OnInit {

    confirmButton = false;
    commonConstants: typeof CommonConstants = CommonConstants;

    constructor(private dialogRef: MatDialogRef<CloneConfirmationPopupComponent>) { }

    ngOnInit() {
    }

    cloneCurrentCost() {
        this.confirmButton = true;
        this.dialogRef.close({ confirmResult: this.confirmButton });
    }

    existingClone() {
        this.confirmButton = false;
        this.dialogRef.close({ confirmResult: this.confirmButton });
    }

    onClosePopup() {
        this.dialogRef.close();
    }

}